import PropTypes from 'prop-types';
import React from 'react';
import diff from 'object-diff';
import { bidStates } from '../../../core/api';
import { formalDate, fromNow, daysBetween } from '../../../core/date';
import BidSendModal from './BidSendModal';
import BidDetailTable from './BidDetailTable';
import BidDetailForm from './BidDetailForm';
import BidDetailNotes from './BidDetailNotes';
import DraftRenderer from '../../../components/DraftRenderer/DraftRenderer';

function getInitialValues(bid) {
  const nights = daysBetween(bid.bidset.event.end, bid.bidset.event.start);
  const initialValues = {
    suites: bid.bidset.suites,
    kings: bid.bidset.kings,
    queens: bid.bidset.queens,
    suite_rate: bid.suite_rate,
    king_rate: bid.king_rate,
    queen_rate: bid.queen_rate,
    hotel: {
      tax_rate: bid.hotel.tax_rate
        ? Number(bid.hotel.tax_rate * 100.0).toFixed(3)
        : bid.hotel.tax_rate,
      currency: bid.hotel.currency,
    },
    commission_rate: bid.commission_rate
      ? Number(bid.commission_rate * 100.0).toFixed(3)
      : bid.commission_rate,
    nights,
  };
  return initialValues;
}
function getUserDisplay(user) {
  if (user) {
    if (user.first_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user.username;
  }
  return 'Unassigned';
}

class BidDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      edit: false,
    };
    this.handleBidSubmit = this.handleBidSubmit.bind(this);
    this.displayBidAssignment = this.displayBidAssignment.bind(this);
    this.close = this.close.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }
  componentDidMount() {
    const bidderState = bidStates[this.props.bid.bidder_state];
    if (bidderState === 'Unread') {
      const payload = {};
      payload.bidder_state = 'VW';
      this.props.editBid(this.props.bid.id, payload);
    }
  }
  handleBidSubmit(values) {
    const payload = diff(getInitialValues(this.props.bid), values);
    if (payload.hotel) {
      if (payload.hotel.tax_rate) {
        payload.hotel.tax_rate = Number(payload.hotel.tax_rate / 100.0).toFixed(3);
      }
    }
    if (payload.commission_rate) {
      payload.commission_rate = Number(payload.commission_rate / 100.0).toFixed(3);
    }
    payload.bidder_state = 'RE';
    payload.bidder = { id: this.props.user.id };
    this.props.editBid(this.props.bid.id, payload);
    this.setState({ edit: false });
  }
  close() {
    this.setState({ showModal: false });
  }
  handleEdit() {
    this.setState({ edit: true });
  }
  displayBidAssignment() {
    this.setState({ showModal: true });
  }
  render() {
    const { bid } = this.props;
    const bidderState = bidStates[bid.bidder_state];
    const isNew = bidderState === 'Unread' || bidderState === 'Viewed';
    const canEdit =
      bidderState === 'Unread' || bidderState === 'Viewed' || bidderState === 'Replied';

    let bidDetail;
    if (isNew || this.state.edit) {
      bidDetail = (
        <BidDetailForm
          initialValues={getInitialValues(this.props.bid)}
          bid={this.props.bid}
          displayBidAssignment={this.displayBidAssignment}
          editBid={this.props.editBid}
          onSubmit={this.handleBidSubmit}
          isNew={isNew}
        />
      );
    } else {
      bidDetail = (
        <BidDetailTable
          bid={this.props.bid}
          displayBidAssignment={this.displayBidAssignment}
          editBid={this.props.editBid}
          canEdit={canEdit}
          handleEdit={this.handleEdit}
        />
      );
    }
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h4>{bid.hotel.name}</h4>
            <p>
              <i className="fa fa-map-marker" />
              {bid.hotel.address}, {bid.hotel.locality}, {bid.hotel.region} {bid.hotel.postcode}
            </p>
            <p>
              {formalDate(bid.bidset.event.start)} -
              {formalDate(bid.bidset.event.end)}
            </p>
            {bid.bidder && <p>Bidder: {getUserDisplay(bid.bidder)}</p>}
            {bid.buyer && <p>Requestor: {getUserDisplay(bid.buyer)}</p>}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <h4>Bid Info</h4>
            {this.props.bid.bidset.event.group_note && (
              <div>{this.props.bid.bidset.event.group_note}</div>
            )}
            {this.props.bid.bidset.event.group_note_json && (
              <div className="panel">
                <DraftRenderer raw={this.props.bid.bidset.event.group_note_json} />
              </div>
            )}

            <div>
              Status: <strong>{bidderState}</strong>
              <br />
              <br />
              <p>
                {bid.sent_on && <span>Send Date: {fromNow(bid.sent_on)}</span>}
                <br />
                {bid.replied_on && (
                  <span>Reply Date: {bid.replied_on && fromNow(bid.replied_on)}</span>
                )}
              </p>
            </div>
          </div>
        </div>

        {bidDetail}

        <div className="row">
          <div className="col-md-12">
            <BidDetailNotes bid={this.props.bid} editBid={this.props.editBid} isNew={isNew} />
          </div>
        </div>
        {this.state.showModal && (
          <BidSendModal
            bid={this.props.bid}
            close={this.close}
            show={this.state.showModal}
            sendBid={this.props.sendBid}
            intialValues={this.props.bid}
          />
        )}
      </div>
    );
  }
}

BidDetail.propTypes = {
  bid: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  editBid: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
};

export default BidDetail;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetail.js